export function timestampMillis(value) {
  if (!value) return 0;
  const ms = value.toMillis ? value.toMillis() : value.toDate ? value.toDate().getTime() : typeof value.seconds === 'number' ? value.seconds * 1000 : new Date(value).getTime();
  return Number.isFinite(ms) ? ms : 0;
}
export function productPriceState(item, now = Date.now()) {
  const verified = timestampMillis(item.lastVerifiedAt);
  const pending = item.priceExtracted === false || item.needsScraping === true || !!item.scrapingError;
  const hasPrice = Number.isFinite(item.currentPrice) && item.currentPrice > 0;
  const fresh = hasPrice && verified > 0 && verified <= now + 300000 && now - verified <= 86400000 && !pending && item.productUnavailable !== true;
  return { fresh, hasPrice, verified, label: item.productUnavailable === true ? 'No disponible en la última comprobación' : fresh ? 'Precio comprobado' : 'Pendiente de actualizar el precio' };
}
